let inMemoryAccessToken = null;

export const tokenStore = {
  getAccessToken: () => inMemoryAccessToken,
  setAccessToken: (token) => {
    inMemoryAccessToken = token;
  },
  clearAccessToken: () => {
    inMemoryAccessToken = null;
  },
};
